export default {
  filter: {
    company_id: null,
    order: null,
    state: null,
    from: null,
    to: null,
    quantity: null,
    comment: null,
    page: 1,
    per_page: 10,
    sortBy: 'id',
    sort: 'DESC',
  },
  measures: {
    medidah4x6: '6',
    medidap4x6: '6',
    medidah7x10: '7',
    medidap7x10: '7',
    medidah18x10: '9',
    medidap18x10: '9',
    medidah21x18: '14',
    medidap21x18: '14',
  },
}



